/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Composables
import { createApp } from 'vue'

// Components
import App from './App.vue'

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful');
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

// Создаем приложение
const app = createApp(App)

// Динамически загружаем плагины
const loadPlugins = async () => {
  const { registerPlugins } = await import('@/plugins')
  registerPlugins(app)
  app.mount('#app')
}

// Запускаем загрузку
loadPlugins().catch(console.error)
